// Enhanced ActivityList.jsx - Grid layout for modern cards
import React from 'react';
import ActivityCard from './ActivityCard';

const ActivityList = ({ activities, onActivityClick }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-2">
      {activities.map((activity) => (
        <ActivityCard
          key={activity.activity_id}
          activity={activity}
          onClick={() => onActivityClick(activity.activity_id)}
        />
      ))}
    </div>
  );
};

export default ActivityList;
